module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAABHNCSVQICAgIfAhkiAAAAQ9JREFUKFONk2FRw1AQhPdTAA6gCloUQBUwdYCEogCQgAIGBeCARgFFAUUBOFhmw0snfSSd7Ex+5N7dd/duEzQi2wtJb5K2klbAz1AqRwAbSZfl/BFYTwbYvpH0VBXMgF0N+TeB7VNJ75LOJX1IyvuZpA2wnAK4l3SXYmBRgN+lcAnkansdTGA7XdM9XRvgKpm2XSp2wOwY4FXSdZcAUNwItNMDkClb7SewnW6xra90i50vvWDszEJbW/uA+D2vAFlawNlJX89AnPoDjNiWo6a4ERdqXQDb3DEL+yyL6yd9lfG78xrQ2hpAZ1ud0G68srHOWQWQZZwMjJhQvrxMkGdITQAH1o0kjoVvR3+mqaBf/5xgh4Zi53UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/warnIcon.png
// module id = KTSw
// module chunks = 3